export default "__VITE_ASSET__Bj9ebL3z__"